import Image from "next/image"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { ArrowRightIcon } from "@/icons"
import { Style } from "@/types/styles"
import { get } from "lodash"
import { getTranslate } from "@/tolgee/server"

export const styles: Style[] = [
  {
    id: 1,
    name: "styles.luxury",
    href: "/collections/luxury", 
  },
  {
    id: 2,
    name: "styles.vintage",
    href: "/collections/vintage",
  },
  {
    id: 3,
    name: "styles.casual",
    href: "/collections/casual",
  },
  {
    id: 4,
    name: "styles.streetwear",
    href: "/collections/streetwear",
  },
  {
    id: 5,
    name: "styles.y2k",
    href: "/collections/y2k",
  },
];


export async function ShopByStyleSection() {
  const t = await getTranslate()
  return (
    <section className="bg-primary container">
      <h2 className="heading-lg text-primary mb-12">{t("shop_by_style.title")}</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
        <div className="py-[52px] px-[58px] h-full border rounded-sm">
          {styles.map((style) => (
            <LocalizedClientLink
              key={style.id}
              href={style.href}
              className="group flex items-center gap-4 text-primary hover:text-action transition-colors border-b border-transparent hover:border-primary w-fit pb-2 mb-8"
            >
              <span className="heading-lg">{t(style.name)}</span>
              <ArrowRightIcon className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
            </LocalizedClientLink>
          ))}
        </div>
        <div className="relative hidden lg:block">
          <Image
            src="/images/shop-by-styles/Image.jpg"
            alt={t("shop_by_style.image_alt")}
            width={700}
            height={600}
            priority
            className="object-cover rounded-sm w-full h-auto"
          />
        </div>
      </div>
    </section>
  )
}
